import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import * as momentNs from 'moment-timezone';
import { TranslateService } from '@ngx-translate/core';
import { OverviewProjectService } from 'src/app/services/overview-project.service';
import { UtilsService } from 'src/app/services/utils.service';
import { DetailProjectService } from 'src/app/services/detail-project.service';
import { InputComponent } from '../../input/input.component';
import { DecimalPipe } from '@angular/common';
import { OverviewStatusPositionQueueComponent } from './overview-status-position-queue/overview-status-position-queue.component';
import { AlertService } from '../../alert/alert.service';
import { PosthogService } from 'src/app/services/posthog.service';
import { DataLayerService } from 'src/app/services/data-layer.service';
import { environment } from 'src/environments/environment';
import { RESERVED_AS_INVESTED } from 'src/app/shared/investment.constants';
const moment = momentNs;

interface RetreeInfo {
  percent: string;
  title: string;
  text: string;
}

@Component({
  selector: 'app-overview-status-project',
  templateUrl: './overview-status-project.component.html',
  styleUrls: ['./overview-status-project.component.scss'],
  providers: [DecimalPipe]
})
export class OverviewStatusProjectComponent implements OnInit, OnChanges {

  // @ViewChild('inputInvest', { static: false }) inputInvestRef: InputComponent;

  @Output() private eventClickViewBTN = new EventEmitter<any>();
  @Output() private downloadAllDocumentsEvent = new EventEmitter<any>();
  @Output() private editInvestEvent = new EventEmitter<any>();
  @Output() private cancelReservationEvent = new EventEmitter<any>();
  @Output() private calculateBeneffitsEvent = new EventEmitter<any>();
  @Input() info: any;
  @Input() isFlexibleCompensation: boolean = false;
  @Input() vinculatinUserList;
  @Input() detailProject: any;
  @Input() profileType: number;

  projectStatus: any;
  projectId: any;
  remainDays: any;
  financiedIn: any;
  end: any;
  profit: number;
  prevent: number;
  hasPrevInvest: boolean;
  btnInvest: string;
  btnInvested: string;

  moneyInvested: any;
  moneyExpected: any;
  percentInv: any;
  leftInv: any;

  daysR: any;
  day: any;
  month: any;
  moreThanAvailable: boolean;
  inputValue: any;

  projectProd = false;
  public formControlKeys = [];
  public errorMessages = {};
  public isSubmit = false;
  public errorLogin = false;
  public isLocalInvestProject = false;
  public localInvestDate: any;

  allowedIncrease = false;
  endPrivateDate: string;

  limitDate: string;
  daysFromStart: any;
  yourInvest = 0;
  yourReservation = 0;
  yourPendingInvest = 0;

  btnMain: string;
  totalOfficialPercent: number;
  contributed: number;
  minExceeded: boolean = false;

  barData: any;
  refisterVinculationSteps = {};
  vinculationMap: any = {
    invest: null,
    validation: null
  };

  originalContributed: number;
  totalRaised: number;
  readonly reservedAsInvested = RESERVED_AS_INVESTED;
  //reservationDate: any;
  listOpened = false;

  userPriorityGroup: any;
  priorityNumber: number;
  priorityInvestedMsg: string;

  reservationList = [];
  preordered: number;
  btnCancelInvestment: string;
  reservationMsg: string;
  reservationStatus: 'danger' | 'warning' | 'safe';

  profitabilityOptions = [1.5, 8, 15.5];
  realTimeProfitability = 8;
  infoRetree: Record<number, RetreeInfo> = {
    1.5: {
      percent: "1,5%",
      title: this.translate.instant('RETREE.LOW.TITLE'),
      text: this.translate.instant('RETREE.LOW.DESC')
    },
    8: {
      percent: "8%",
      title: this.translate.instant('RETREE.NORMAL.TITLE'),
      text: this.translate.instant('RETREE.NORMAL.DESC')
    },
    15.5: {
      percent: "15,5%",
      title: this.translate.instant('RETREE.HIGHT.TITLE'),
      text: this.translate.instant('RETREE.HIGHT.DESC')
    }
  };
  disableBtnInvest: boolean = false;

  get isProfileRestricted(): boolean {
    return (this.detailProject?.canLegalInvest === false && this.profileType === 2) ||
      (this.detailProject?.canNaturalInvest === false && this.profileType === 1);
  }

  get isLocalInvestorsOnly(): boolean {
    const stages = this.detailProject?.postal_code_investment_stages || [];
    const hasPriorityGroups = stages.some((s: any) => s.priority_groups?.length > 0);
    const hasGlobalPhase = stages.some((s: any) => s.type === 3);
    const userHasGroup = this.detailProject?.priority_groups?.some((pg: any) => pg.isEnabledForUser);
    return hasPriorityGroups && !hasGlobalPhase && !userHasGroup;
  }

  get hasGlobalPhase(): boolean {
    const stages = this.detailProject?.postal_code_investment_stages || [];
    return stages.some((s: any) => s.type === 3);
  }

  get showClosedStatusBadge(): boolean {
    return this.projectStatus === 9 || this.projectStatus === 10 || this.projectStatus === 13;
  }

  get closedStatusBadgeText(): string {
    if (this.projectStatus === 9) { return 'Fin de vida'; }
    if (this.projectStatus === 10) { return 'Vendido'; }
    if (this.projectStatus === 13) { return 'Reembolsado'; }
    return '';
  }

  get showTotalAsObjective(): boolean {
    const statuses = [5, 6, 7, 8, 9, 10, 11, 13, 16];
    return statuses.includes(this.projectStatus) && !!this.info?.total
      && !(this.projectStatus === 9 && this.projectId === 17);
  }

  globalGroupNumber: number;
  moicVariant: string | null = null;
  moicValue: string = '';
  positionList: any;
  isLocalPhase: boolean = false;
  currentStage: any;

  constructor(
    private translate: TranslateService,
    private overviewService: OverviewProjectService,
    private utils: UtilsService,
    private chdRef: ChangeDetectorRef,
    private detailProjectService: DetailProjectService,
    private decimalPipe: DecimalPipe,
    private alertService: AlertService,
    private posthogService: PosthogService,
    private dataLayerService: DataLayerService
  ) { }

  ngOnInit() {
    this.currentStage = this.getCurrentActiveStage();
    this.originalContributed = this.info.contributed;
    this.totalRaised = (this.info.contributed || 0) + (this.info.reserved || 0) + (this.info.preordered || 0);
    this.btnCancelInvestment = this.translate.instant('movements.cancel_investment');
    if (this.vinculatinUserList && this.vinculatinUserList.length > 0) {
      this.vinculationMap = this.getStepStatusMap(this.vinculatinUserList);
    }
    this.getAsideData();
    this.moicValue = (1 + this.info.profitability / 100).toFixed(2).replace('.', ',') + 'x';
    if (!environment.production) {
      this.moicVariant = 'moic';
    } else {
      this.posthogService.getExperimentVariant('moic-vs-roi').then(result => {
        this.moicVariant = result?.value as string || null;
        this.posthogService.pushEventParams('experiment_viewed', {
          experiment: 'moic-vs-roi',
          variante: this.moicVariant,
          project_id: this.info.id
        });
        this.dataLayerService.pushCustomEventGTM('experiment_viewed');
        this.chdRef.detectChanges();
      });
    }
    if (this.info.prevInvestmentsAndReservesWithDetail && this.info.prevInvestmentsAndReservesWithDetail.length > 0) {
      const reservations = this.info.prevInvestmentsAndReservesWithDetail.filter((item: any) => item.status === -3);
      if (reservations.length > 0) {
        reservations.forEach((reservation: any) => {
          const amountFormatted = this.decimalPipe.transform(reservation.amount, '1.0-0', 'es');
          this.reservationMsg = this.translate.instant('OVERVIEW_PROJECT.RESERVATION.GENERIC', {
            amount: amountFormatted
          });
        });
      }
    }
    this.chdRef.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['profileType'] && this.detailProject) {
      if (this.detailProject?.canLegalInvest === false && this.profileType === 2) {
        this.disableBtnInvest = true;
      }
      if (this.detailProject?.canNaturalInvest === false && this.profileType === 1) {
        this.disableBtnInvest = true;
      }
      this.chdRef.detectChanges();
    }
  }

  getObjetiveParse() {
    if (this.info.total < 1000000) {
      return this.decimalPipe.transform(this.info.total, '1.0-0', 'es') + ' €';
    } else {
      const millionsObj = this.info.total / 1000000;
      return this.decimalPipe.transform(millionsObj, '1.0-2', 'es') + ' M€';
    }
  }

  getAsideData() {
    const totalInvested = this.originalContributed + (this.reservedAsInvested ? (this.info.reserved || 0) : 0);
    const totalRaisedAll = this.originalContributed + (this.info.reserved || 0) + (this.info.preordered || 0);
    if ((totalRaisedAll > this.info.total_official) && (this.info.total_official > 0)) {
      this.minExceeded = true;
    }

    this.barData = {
      contributed: totalInvested,
      contributed_intention: this.info.contributed_intention,
      id: this.info.id,
      status: this.info.status,
      reserved: (this.info.reserved || 0) + (this.info.preordered || 0),
      comprometido: 0,
      reservado: 0,
      total: this.info.total,
      total_official: this.info.total_official,
      total_parse: this.getObjetiveParse(),
      min_exceeded: this.minExceeded,
      reservedDisplayAmount: (RESERVED_AS_INVESTED ? 0 : (this.info.reserved || 0)) + (this.info.preordered || 0),
      currentStage: this.currentStage,
      autoinvested: this.info.autoinvested || 0,
      autoinvestedPreordered: this.info.autoinvestedPreordered || 0
    };

    this.btnMain = this.isFlexibleCompensation ? 'ricEnergyDark' : 'primaryDark';
    registerLocaleData(es);
    if (this.info.prevInvest !== undefined) {
      for (let i = 0; i < this.info.prevInvest.length; i++) {
        if (this.info.prevInvest[i].status !== -3) {
          this.yourInvest = this.yourInvest + this.info.prevInvest[i].invested;
        } else {
          this.yourReservation = this.yourReservation + this.info.prevInvest[i].invested;
          this.reservationList.push(this.info.prevInvest[i]);
        }


      }
      if (this.info.investmentsPendingSign && this.info.investmentsPendingSign.length > 0) {
        for (let i = 0; i < this.info.investmentsPendingSign.length; i++) {
          this.yourPendingInvest = this.yourPendingInvest + this.info.investmentsPendingSign[i].amount;
          this.yourInvest = this.yourInvest - this.yourPendingInvest;
        }
      }
    }
    if (
      this.info.max_allowed_amount_to_invest_for_user !== null
      && this.info.max_allowed_amount_to_invest_for_user !== undefined
    ) {
      this.allowedIncrease = true;
    }
    if (this.info.status === 14) {
      this.endPrivateDate = this.getEndPrivateDay();
    }
    if (this.info.status === 5 || this.info.status === 6 || this.info.status === 7) {
      this.financiedIn = this.getFinanciedIn();
    }
    if (this.info.total_official && this.info.total_official > 0) {
      this.totalOfficialPercent = (this.info.total_official * 100) / this.info.total;
    }
    this.moreThanAvailable = true;
    this.getBtnTitle();
    this.projectStatus = this.info.status;
    this.projectId = this.info.id;
    let now = new Date(this.convertToIos(moment().format('YYYY-MM-DD HH:mm:ss'))).getTime();
    let start = new Date(
      this.convertToIos(moment(this.info.start_date).format('YYYY-MM-DD') + ' 00:00:00')
    ).getTime();
    let endDateN = new Date(
      this.convertToIos(moment(this.info.end_date).format('YYYY-MM-DD') + ' 00:00:00')
    ).getTime();
    if (isNaN(endDateN)) {
      endDateN = new Date(
        this.convertToIos(moment(this.info.end_date.replace('/', '-').replace('/', '-')).format('YYYY-MM-DD') + ' 00:00:00')
      ).getTime();
      now = new Date(moment().format('YYYY-MM-DD HH:mm:ss')).getTime();
      start = new Date(
        this.convertToIos(moment(this.info.start_date.replace('/', '-').replace('/', '-')).format('YYYY-MM-DD') + ' 00:00:00')
      ).getTime();
    }
    this.daysR = Math.ceil((endDateN - now) / (1000 * 60 * 60 * 24));
    if (this.daysR > 1) {
      this.remainDays = this.translate.instant('OVERVIEW.NUMBER_DAYS', { days: this.daysR });
    } else if (this.daysR === 1) {
      this.remainDays = this.translate.instant('OVERVIEW.TOMORROW');
    } else {
      this.remainDays = this.translate.instant('OVERVIEW.TODAY');
    }
    this.end = moment(this.info.end_date.replace('/', '-').replace('/', '-')).format('DD/MM/YYYY');
    if (this.info.status === 15 || this.info.status === 12 || this.info.status === 4) {
      this.getFinancingDates(this.end, now, start);
    }

    this.contributed = (RESERVED_AS_INVESTED ? (this.info.reserved || 0) : 0) + this.info.contributed;

    if (this.vinculatinUserList && this.vinculatinUserList.length > 0) {
      //registerVinculationOk = false;
      //investVinculationOk = false;
    }
    if (this.detailProject.priority_groups && this.detailProject.priority_groups.length > 0) {
      const priorityGroups = this.detailProject.priority_groups;

      // Ordenar grupos por prioridad (menor número = mayor prioridad)
      const sortedGroups = priorityGroups.slice().sort((a, b) => a.priority - b.priority);
      this.globalGroupNumber = sortedGroups[sortedGroups.length - 1].priority + 1;

      // Encontrar el grupo del usuario con mayor prioridad que no esté lleno
      const userGroups = sortedGroups.filter((pg: any) => pg.isEnabledForUser);
      this.userPriorityGroup = userGroups.find((pg: any) => !pg.isGroupObjetiveFull) || null;
      this.priorityNumber = this.userPriorityGroup && this.userPriorityGroup.priority ? this.userPriorityGroup.priority : null;
      // Necesito saber la fase actual y ver si es global
      if (this.currentStage.type !== 3) {
        switch (this.priorityNumber) {
          case 0:
            this.priorityInvestedMsg = this.translate.instant('OVERVIEW.PRIORITY.MSG_EFFECTIVE');
            break;
          case 1:
            this.priorityInvestedMsg = this.translate.instant('OVERVIEW.PRIORITY.MSG_EFFECTIVE');
            break;
          default:
            this.priorityInvestedMsg = this.translate.instant('OVERVIEW.PRIORITY.MSG_WARNING');
            break;
        }
      } else {
        this.priorityInvestedMsg = null;
      }

    }

    this.checkLocalInvest();
    this.chdRef.detectChanges();
  }

  getEndPrivateDay() {
    const check = moment(this.info.capital_increase_private_end_date, 'YYYY/MM/DD');
    const day = Number(check.format('DD'));
    const month = this.utils.parseMonth(Number(check.format('MM')));
    const year = Number(check.format('YYYY'));
    return this.translate.currentLang === 'en' ? `${month} ${day}th, ${year}` : `${day} de ${month} de ${year}`;
  }

  btnClick(evt) {
    if (evt === 'marketplace') {
      if (this.info.hasMarketplace) {
        if (this.info.prevInvest !== undefined) {
          this.eventClickViewBTN.emit('offer');
        } else {
          this.eventClickViewBTN.emit(evt);
        }
      } else {
        this.eventClickViewBTN.emit('updates');
      }
    } else if (evt === 'info') {
      this.overviewService.openCapitalIncreaseMoreInfo(this.info.available);
    } else {
      this.eventClickViewBTN.emit(evt);
    }
  }

  getBtnTitle() {
    // Verificar si estamos en fase de reservas (stage.type === 1) o grupos prioritarios (stage.type === 2)
    const isReservationPhase = this.currentStage && this.currentStage.type === 1;
    const isPriorityGroupPhase = this.currentStage && this.currentStage.type === 2;

    // En fase de grupos prioritarios, verificar si el usuario pertenece a algún grupo
    const userHasPriorityGroup = isPriorityGroupPhase &&
      this.detailProject?.priority_groups?.some((pg: any) => pg.isEnabledForUser);

    if (this.info.investmentsPendingSign && this.info.investmentsPendingSign.length > 0) {
      this.btnInvest = this.translate.instant('OVERVIEW_PROJECT.GROUPS.CTA.FORMALIZE');
    } else if (isReservationPhase) {
      // Fase de reservas
      this.btnInvest = this.translate.instant('OVERVIEW_PROJECT.GROUPS.CTA.RESERVE');;
      this.btnCancelInvestment = this.translate.instant('OVERVIEW.BTN.CANCEL_RESERVATION');
      this.hasPrevInvest = false;
      this.leftInv = ((this.contributed / this.info.total) * 100) + '%';
    } else if (isPriorityGroupPhase && !userHasPriorityGroup) {
      // Fase de grupos prioritarios pero el usuario no pertenece a ninguno
      this.btnInvest = this.translate.instant('OVERVIEW_PROJECT.GROUPS.CTA.RESERVE');;
      this.btnCancelInvestment = this.translate.instant('OVERVIEW.BTN.CANCEL_RESERVATION');
      this.hasPrevInvest = false;
      this.leftInv = ((this.contributed / this.info.total) * 100) + '%';
    } else if (this.info.prevInvest && this.info.prevInvest !== undefined && (this.info.status === 4 || this.info.status === 12 || this.info.status === 14 || this.info.status === 15)) {
      this.hasPrevInvest = true;
      this.translate.get('overview.status.invert-again').subscribe((title) => {
        this.btnInvest = title;
      });
      this.getPrevInvest(this.info.prevInvest);
    } else {
      this.hasPrevInvest = false;
      this.translate.get('overview.status.invest').subscribe((title) => {
        this.btnInvest = title;
      });
      this.leftInv = ((this.contributed / this.info.total) * 100) + '%';
    }
    if (this.info.status > 4 && this.info.status < 12) {
      if (this.info.hasMarketplace && this.info.hasMarketplace !== undefined) {
        if (this.info.prevInvest !== undefined) {
          this.translate.get('overview.status.publish').subscribe((title) => {
            this.btnInvested = title;
          });
        } else {
          this.translate.get('overview.status.see-offers').subscribe((title) => {
            this.btnInvested = title;
          });
        }
      } else {
        this.translate.get('overview.status.see-news').subscribe((title) => {
          this.btnInvested = title;
        });
      }
    } else {
      this.translate.get('overview.status.see-news').subscribe((title) => {
        this.btnInvested = title;
      });
    }
    if (this.detailProject.is_consolidation_date && (!this.info.investmentsPendingSign || this.info.investmentsPendingSign.length === 0)) {
      this.disableBtnInvest = true;
    }
    if (this.detailProject?.canLegalInvest === false && this.profileType === 2) {
      this.disableBtnInvest = true;
    }
    if (this.detailProject?.canNaturalInvest === false && this.profileType === 1) {
      this.disableBtnInvest = true;
    }
  }

  getPrevInvest(prev) {
    const invested = [];
    const moneyExpected = [];
    prev.forEach(element => {
      invested.push(element.invested);
      moneyExpected.push(element.totalRevenue);
    });
    this.moneyInvested = invested.reduce((a, b) => a + b, 0);
    this.moneyExpected = moneyExpected.reduce((a, b) => a + b, 0);
    this.percentInv = (this.moneyInvested / this.info.total) * 100 + '%';
    this.leftInv = (((this.contributed / this.info.total) * 100)) + '%';
  }

  getFinancingDates(end, now, start) {
    const day = Number(end.substring(0, 2));
    const month = this.utils.parseMonthShort(Number(end.substring(3, 5)));
    this.limitDate = `${day} ${month}`;
    this.daysFromStart = Math.floor(Math.abs((now - start) / (1000 * 60 * 60 * 24)));
  }

  getFinanciedIn() {
    const startDate = this.info.start_date;
    const endDate = this.info.end_date;
    let endDateN;
    let startDateN;
    let hour;
    endDateN = new Date(this.convertToIos(moment(endDate).format('YYYY-MM-DD  HH:mm:ss'))).getTime();
    startDateN = new Date(this.convertToIos(moment(startDate).format('YYYY-MM-DD  HH:mm:ss'))).getTime();
    if (endDateN === isNaN || endDateN === undefined || !endDateN) {
      endDateN = new Date(
        this.convertToIos(moment(endDate.replace('/', '-').replace('/', '-')).format('YYYY-MM-DD  HH:mm:ss'))
      ).getTime();
      startDateN = new Date(
        this.convertToIos(moment(startDate.replace('/', '-').replace('/', '-')).format('YYYY-MM-DD  HH:mm:ss'))
      ).getTime();
    }

    const h = (new Date(endDateN).getTime() - new Date(startDateN).getTime()) / (1000 * 60);
    if (h <= 1) {
      this.translate.get('overview.status.less-than-hour').subscribe((title) => {
        hour = title;
      });
    } else {
      if (h > 1 && h < 2) {
        this.translate.get('overview.status.one-hour').subscribe((title) => {
          hour = title;
        });
      } else {
        hour = this.translate.instant('OVERVIEW.FINANCED_IN', { hour: Math.floor(h) });
      }
    }
    const timeLeft = (endDateN - startDateN) / (1000 * 60 * 60 * 24);
    if (timeLeft < 1) {
      return hour;
    } else if (timeLeft > 1 && timeLeft < 2) {
      this.translate.get('overview.status.financied-day').subscribe((title) => {
        return title;
      });
    }
    return this.translate.instant('OVERVIEW.FINANCED_IN_DAYS', { days: Math.round(timeLeft) });
  }

  convertToIos(date) {
    const arr = date.split(/[- :]/);
    const r = new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4], arr[5]);
    return r;
  }

  checkLocalInvest() {
    if (
      (this.info.status === 4 || this.info.status === 12)
      && this.info.postalCodeToInvest
      && this.info.postalCodeDate !== null
      && this.info.postalCodeDate !== undefined
      && !this.info.postalCodeCanInvest
    ) {
      this.isLocalInvestProject = true;
      let dateParse = new Date(this.convertToIos(moment(this.info.postalCodeDate).tz('Europe/Madrid').format('YYYY-MM-DD HH:mm:ss')));
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        dateParse = new Date(this.convertToIos(moment(this.info.postalCodeDate.replace('/', '-').replace('/', '-'))
          .tz('Europe/Madrid').format('YYYY-MM-DD HH:mm:ss')));
      }
      const day = moment(dateParse).date();
      const month = this.utils.parseMonth(moment(dateParse).month() + 1);
      const year = moment(dateParse).year();
      this.localInvestDate = this.translate.instant('OVERVIEW.PROJECT_RESERVATED', { day: day, month: month, year: year });
    }
  }

  editInvest() {
    this.editInvestEvent.emit();
  }

  reserveInvestment() {
    this.eventClickViewBTN.emit('invest');
  }

  downloadAllDocuments() {
    this.downloadAllDocumentsEvent.emit();
  }

  calculateB() {
    this.calculateBeneffitsEvent.emit();
  }

  getStepStatusMap(data) {
    // Prioridad de los estados
    const priorityOrder = ["validado", "pendiente", "rechazado"];

    const result = {};

    data.forEach(item => {
      const { step, status } = item.attributes;

      // Si aún no hay un status asignado para este step o el nuevo tiene más prioridad
      if (!result[step] || priorityOrder.indexOf(status) < priorityOrder.indexOf(result[step])) {
        result[step] = status;
      }
    });

    return result;
  }

  getCurrentActiveStage(): any {
    if (!this.detailProject || !this.detailProject.postal_code_investment_stages) {
      return null;
    }
    const stages = this.detailProject.postal_code_investment_stages;
    for (let i = 0; i < stages.length; i++) {
      if (this.detailProjectService.getIfIsStageActive(i, this.detailProject)) {
        return stages[i];
      }
    }
    return null;
  }

  togglePriorityList() {
    this.listOpened = !this.listOpened;
    this.chdRef.detectChanges();
  }

  cancelReservaion() {
    this.cancelReservationEvent.emit();
  }

  setRealTimeProfitability(value: number): void {
    this.realTimeProfitability = value;
  }

  viewMyPositionInQueue() {
    const modalParams = {
      positionList: this.positionList,
      projectId: this.projectId
    };
    this.alertService.showModal(OverviewStatusPositionQueueComponent, modalParams, '', '', true).subscribe((modal: any) => {
      modal.getChildComponent().subscribe((componentRef: OverviewStatusPositionQueueComponent) => {
        componentRef.setPositionListEvent.subscribe((value) => {
          this.positionList = value;
        });
      });
      modal.onClose().subscribe();
      modal.activeCross().subscribe();
    });
  }

}
